// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"member"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 20V19C16 16.7909 14.2091 15 12 15H5C2.79086 15 1 16.7909 1 19V20M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15.5 11C17.7091 11 19.5 9.20914 19.5 7C19.5 4.79086 17.7091 3 15.5 3M23 20V19C23 16.7909 21.2091 15 19 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MemberIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'member',
    ref,
    icon: element,
  },
));

MemberIcon.displayName = 'MemberIcon';

export default MemberIcon;
